import React from 'react';
import PropTypes from 'prop-types';

import { Spacer, Text } from '@kueski-dev/kueski-design-system';

import { ButtonContainer } from 'Components/ButtonHome/ButtonHome.styles';

import IconReload from './icon-reload.svg';

const ButtonReload = ({ className, text }) => {
  const handleClick = () => {
    window.location.reload();
  };

  return (
    <ButtonContainer className={className} onClick={handleClick} role="button">
      <IconReload />
      <Spacer $size="layout01" />
      <Text $format="Title/Small/Bold" $color="textPrimary" $align="center">
        {text}
      </Text>
    </ButtonContainer>
  );
};

ButtonReload.defaultProps = {
  className: '',
  text: 'Recargar página',
};

ButtonReload.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
};

export default ButtonReload;
